import { render, staticRenderFns } from "./MobileAssetHistory.vue?vue&type=template&id=0634d8cd&scoped=true"
import script from "./MobileAssetHistory.vue?vue&type=script&lang=ts"
export * from "./MobileAssetHistory.vue?vue&type=script&lang=ts"
import style0 from "./MobileAssetHistory.vue?vue&type=style&index=0&id=0634d8cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634d8cd",
  null
  
)

export default component.exports